<ng-container *ngFor="let numberOfSkeleton of skeleton?.count">
<p-skeleton [size]="skeleton?.size" [shape]="skeleton?.shape" [width]="skeleton?.width" [height]="skeleton?.height" [styleClass]="skeleton?.class"></p-skeleton>
</ng-container>